import { baseApi } from "@/redux/api/baseApi";

const shippingAddress = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getShippingAddresses: builder.query({
      query: (email) => ({
        url: `/creator-shipping?email=${email}`,
        method: "GET",
      }),
      providesTags: ["shippingAddress"],
    }),

    uploadShippingAddresses: builder.mutation({
      query: (body) => ({
        url: `/creator-shipping/add`,
        method: "POST",
        body: body,
      }),
      invalidatesTags: ["shippingAddress"],
    }),
    editShippingAddresses: builder.mutation({
      query: ({ email, addressData }) => ({
        url: `/creator-shipping/edit/${email}`,
        method: "PUT",
        body: addressData,
      }),
      invalidatesTags: ["shippingAddress"], // Optionally invalidate cache to refresh
    }),

    // New Delete Mutation
    deleteShippingAddresses: builder.mutation({
      query: (id) => ({
        url: `/creator-shipping/delete/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["shippingAddress"], // Optionally invalidate cache to refresh
    }),
  }),
});

export const {
  useGetShippingAddressesQuery,
  useUploadShippingAddressesMutation,
  useDeleteShippingAddressesMutation,
  useEditShippingAddressesMutation,
} = shippingAddress;
